import { render, staticRenderFns } from "./FalconAd.vue?vue&type=template&id=993d3920&scoped=true&"
import script from "./FalconAd.vue?vue&type=script&lang=js&"
export * from "./FalconAd.vue?vue&type=script&lang=js&"
import style0 from "./FalconAd.vue?vue&type=style&index=0&id=993d3920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993d3920",
  null
  
)

export default component.exports